import { Circle, Lock, Schedule, CheckCircle } from '@mui/icons-material';

import { TaskStatus } from './LaunchpadProgress.interface';

const STATUS_CONFIG: Record<TaskStatus, { icon: typeof CheckCircle }> = {
    [TaskStatus.NOT_READY]: {
        icon: Lock,
    },
    [TaskStatus.COMPLETED]: {
        icon: CheckCircle,
    },
    [TaskStatus.PENDING]: {
        icon: Schedule,
    },
    [TaskStatus.READY]: {
        icon: Schedule,
    },
    [TaskStatus.IN_PROGRESS]: {
        icon: Circle,
    },
    [TaskStatus.BLOCKED]: {
        icon: Lock,
    },
    [TaskStatus.WAITING]: {
        icon: Lock,
    },
    [TaskStatus.CANCELLED]: {
        icon: Schedule,
    },
};

export const getStatusConfig = (status: TaskStatus) => {
    return STATUS_CONFIG[status] || STATUS_CONFIG[TaskStatus.READY];
};
